<nb-select fullWidth
           [placeholder]="placeholder()"
           [(selected)]="value"
           [disabled]="isDisabled">
  @for (v of values; track v) {
    <nb-option [value]="v">{{ v | labelCategoryTranslation }}</nb-option>
  }
</nb-select>
